/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
import Vue from 'vue';
import Vuex from 'vuex';
import notificationService from '@/services/notificationService';
import rawmaterialsModule from './modules/rawmaterialsModule';
import articlesModule from './modules/articlesModule';
import employeesModule from './modules/crm/employeesModule';
import projectsModule from './modules/projects/projectsModule';
import catalogsModule from './modules/catalogsModule';
import settingsModule from './modules/settingsModule';
import AuthenticationService from '@/auth/AuthenticationService';
import tasksRepository from '@/services/varia/tasksRepository';
import measuringUnitsModule from './modules/measuringUnitsModule';

import axios from 'axios';
import settings from '@/settings.json';
import actionPointsRepository from '@/modules/actionPoints/repository/actionPointsRepository';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    rawmaterials: rawmaterialsModule,
    articles: articlesModule,
    employees: employeesModule,
    projects: projectsModule,
    catalogs: catalogsModule,
    settings: settingsModule,
    measuringUnits: measuringUnitsModule
  },
  state: {
    initialised: false,
    currentUser: {},
    zenmode: false,
    numberOfTasks: 0,
    numberOfNotifications: 0,
    numberOfActionPoints: 0,
    production: true,
  },
  getters: {
    currentUser: (state) => state.currentUser,
    zenmode: (state) => state.zenmode,
    initialised: (state) => state.initialised,
    numberOfTasks: (state) => state.numberOfTasks,
    numberOfNotifications: (state) => state.numberOfNotifications,
    numberOfActionPoints: (state) => state.numberOfActionPoints,
    inProduction: (state) => state.production,
  },
  mutations: {
    setCurrentUser(state, object) {
      state.initialised = true;
      state.currentUser = object;
    },
    setNumberOfTasks(state, amount) {
      state.numberOfTasks = amount;
    },
    setNumberOfNotifications(state, amount) {
      state.numberOfNotifications = amount;
    },
    setZenmode(state, value) {
      state.zenmode = value;
    },
    setProduction(state, value) {
      state.production = value;
    },
    setNumberOfActionPoints(state, amount) {
      state.numberOfActionPoints = amount;
    },
  },
  actions: {
    async fetch({ state, commit, dispatch }) {
      if (!state.initialised) {
        await dispatch('load');
        dispatch('loadNumberOfTasks');
        dispatch('loadNumberOfActionPoints');
      }

      try {
        commit('setProduction', (await axios.get(settings.api + '/env')).data.production);
      } catch {
        // Do nothing
      }
    },
    async load({ commit }) {
        try {
            commit('setCurrentUser', (new AuthenticationService()).getUser());
        } catch (err) {
            notificationService.failedToLoad();
        }
    },
    async loadNumberOfTasks({ commit }) {
      try {
          commit('setNumberOfTasks', (await tasksRepository.getCountOfMyTasks()).data);
      } catch (err) {
          notificationService.failedToLoad();
      }
    },
    async loadNumberOfActionPoints({ commit }) {
      try {
          commit('setNumberOfActionPoints', (await actionPointsRepository.getCountOfMyActionPoints()).data);
      } catch (err) {
          notificationService.failedToLoad();
      }
    },
  },
});
